function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_410_167005)"
}, React.createElement("rect", {
  width: 37,
  height: 37,
  rx: 18.5,
  fill: "white"
}), React.createElement("path", {
  d: "M34.1296 6.08044C31.3157 6.44784 28.5149 7.12297 25.7767 8.12287",
  stroke: "#CCCCCC",
  strokeWidth: 4.61628,
  strokeMiterlimit: 200
}), React.createElement("path", {
  d: "M10.252 18.4819C8.28903 20.6186 6.59003 22.9479 5.16792 25.4168",
  stroke: "#CCCCCC",
  strokeWidth: 4.61628,
  strokeMiterlimit: 200
}), React.createElement("path", {
  d: "M21.1026 10.1854C20.5871 10.4533 20.0752 10.731 19.5666 11.0246C17.5484 12.1898 15.6756 13.5071 13.9481 14.9525",
  stroke: "#D6002A",
  strokeWidth: 4.68859,
  strokeMiterlimit: 200
}), React.createElement("path", {
  d: "M2.91016 30C1.81009 32.6558 1.00149 35.4248 0.501165 38.2539",
  stroke: "#CCCCCC",
  strokeWidth: 4.61628,
  strokeMiterlimit: 200
}), React.createElement("path", {
  d: "M45.9266 14.994C40.3058 13.7419 34.3246 14.0501 28.6834 16.1113",
  stroke: "#CCCCCC",
  strokeWidth: 4.61628,
  strokeMiterlimit: 200
}), React.createElement("path", {
  d: "M25.0202 17.7285C24.6158 17.9381 24.2142 18.1561 23.8156 18.3863C18.9524 21.194 15.1439 25.128 12.5297 29.6673",
  stroke: "black",
  strokeWidth: 4.61628,
  strokeMiterlimit: 200
}), React.createElement("path", {
  d: "M10.7617 33.2603C8.53312 38.6358 7.83631 44.6003 8.86512 50.4351",
  stroke: "#CCCCCC",
  strokeWidth: 4.61628,
  strokeMiterlimit: 200
}), React.createElement("path", {
  d: "M44.0806 23.2919C38.8137 22.117 33.1082 22.8373 28.0665 25.7481C19.7113 30.5719 15.6543 39.9795 17.2382 48.9601",
  stroke: "#767676",
  strokeWidth: 4.61628,
  strokeMiterlimit: 200
}));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 36,
  height: 36,
  rx: 18,
  stroke: "#CCCCCC"
});
var _ref4 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_410_167005"
}, React.createElement("rect", {
  width: 37,
  height: 37,
  rx: 18.5,
  fill: "white"
})));
var SvgProductFinderButtonImg = function SvgProductFinderButtonImg(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProductFinderButtonImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product-finder-button-img.319db219.svg";
export { ForwardRef as ReactComponent };